import $ from 'jquery';
import bootbox from 'bootbox';
import { domSelectors } from "~/globals";
import { t } from "~/hooks/useI18n";

const unbindWaiting = () => {
    $(document).off("ajaxSend");
    $(document).off("ajaxComplete");
};



const bindWaiting = () => {
    $(document)
        .off("ajaxSend")
        .off("ajaxComplete")
        .on("ajaxSend", () => {
            // $("#loading").css("display", ""); 
        })
        .on("ajaxComplete", () => {
            $("#loading").css("display", "none"); // TODO: entry in domSelectors
        });
}

const delay = (ms: number) => new Promise<void>(r => setTimeout(r, ms));

const message = (text: string, callback?: () => void) => {

    hideWait();
    return new Promise<void>((resolve) => {
        bootbox.alert({
            title: " ",
            //title: "<img width='36px' src='../images/loghi/logo_atp-segnografico.svg'>",
            message: text,
            callback: function () {
                if (typeof (callback) === "function") {
                    callback();
                }
                resolve();
            }
        });
    })
}

const confirm = (titolo: string, messaggio: string, size?: string, closeCallback?: (result: boolean) => void) => {
    hideWait();

    return new Promise<boolean>((resolve) => {
        bootbox.confirm({
            title: titolo,
            message: messaggio,
            className: size || "", // Classe per modale di dimensione media, Usa stringa vuota se size non è passato
            closeButton: false,
            animate: true,
            buttons: {
                cancel: {
                    label: 'Annulla',
                    className: 'btn-secondary'
                },
                confirm: {
                    label: 'Conferma',
                    className: 'btn-primary'
                }
            },
            callback: function (result) {
                if (typeof (closeCallback) === 'function')
                    closeCallback(result);

                resolve(result);
            }
        });
    });
}

const confirmWithButtonOkCustom = (titolo: string, messaggio: string, lblButtonOk?: string, size?: string, closeCallback?: (result: boolean) => void) => {
    hideWait();

    return new Promise<boolean>((resolve) => {
        bootbox.confirm({
            title: titolo,
            message: messaggio,
            className: size || "", // Classe per modale di dimensione media, Usa stringa vuota se size non è passato
            closeButton: false,
            animate: true,
            buttons: {
                cancel: {
                    label: 'Annulla',
                    className: 'btn-secondary'
                },
                confirm: {
                    label: lblButtonOk || 'Conferma',
                    className: 'btn-primary'
                }
            },
            callback: function (result) {
                if (typeof (closeCallback) === 'function')
                    closeCallback(result);

                resolve(result);
            }
        });
    });
}

const confirmOneButton = (titolo: string, messaggio: string, size?: string, closeCallback?: (result: boolean) => void) => {
    hideWait();

    return new Promise<boolean>((resolve) => {
        bootbox.confirm({
            title: titolo,
            message: messaggio,
            className: size || "", // Classe per modale di dimensione media, Usa stringa vuota se size non è passato
            backdrop: undefined, //Undefined (null)	The backdrop is displayed, but clicking on it has no effect.
            closeButton: false,
            onEscape: false,
            animate: true,
            buttons: {
                cancel: {
                    label: 'Annulla',
                    className: 'd-none'
                },
                confirm: {
                    label: 'Ok',
                    className: 'btn-primary'
                }
            },
            callback: function (result) {
                if (typeof (closeCallback) === 'function')
                    closeCallback(result);

                resolve(result);
            }
        });
    });

}
const confirmOneButtonCustom = (titolo: string, messaggio: string,
    lblButtonOk: string, size?: string, closeCallback?: (result: boolean) => void) => {
    hideWait();

    return new Promise<boolean>((resolve) => {
        bootbox.confirm({
            title: titolo,
            message: messaggio,
            className: size || "", // Classe per modale di dimensione media, Usa stringa vuota se size non è passato
            backdrop: undefined,
            closeButton: false,
            onEscape: false,
            animate: true,
            buttons: {
                cancel: {
                    label: 'Annulla',
                    className: 'd-none'
                },
                confirm: {
                    label: lblButtonOk || 'Conferma',
                    className: 'btn-primary'
                }
            },
            callback: function (result) {
                if (typeof (closeCallback) === 'function')
                    closeCallback(result);
                resolve(result);
            }
        });
    });
}

// Funzione prompt OTP con Bootbox
// In `Inlinea.VenditePrivate.Web/App_Client/src/js/ui.ts`
const promptOtp = (codeTitle: string = "Verifica il tuo numero di telefono", resend: boolean = false): Promise<string> => {
    hideWait();

    return new Promise<string>((resolve, reject) => {
        const inputsHtml = Array.from({ length: 6 })
            .map((_, i) =>
                `<input type="text" inputmode="numeric" autocomplete="one-time-code"
                    class="otp-digit form-control text-center mx-1 p-0 fw-bold"
                    style="width:48px;height:56px;font-size:26px;"
                    maxlength="1" data-index="${i}" aria-label="Cifra ${i + 1}" />`)
            .join("");

        const dlg = bootbox.dialog({
            title: codeTitle,
            message: `
                <div class="d-flex flex-column align-items-center">
                <div class="mb-2">${t("messages.enterOtpCode")}</div>
                  <div class="d-flex justify-content-center mb-2">${inputsHtml}</div>
                  <div id="otpError" class="text-danger small d-none">
                      ${t("messages.insertCodeNrCifre")}
                  </div>
                  <div class="mt-2 ${ resend ? '' : 'd-none' }"><a href="#" id="otpResendLink" class="small">${t("messages.resendCode")}</a></div>
                  <div class="mt-2 d-none">${t("messages.otpNotReceived")}<a href="#" id="otpResendLinkTimeout" class="small">${t("messages.resendCode")}</a></div>
                </div>
            `,
            closeButton: false,
            onEscape: () => { reject(new Error("cancelled")); },
            buttons: {
                cancel: {
                    label: t("common.annulla"),
                    className: "btn-outline-secondary",
                    callback: () => { reject(new Error("cancelled")); }
                },
                confirm: {
                    label: t("common.verifica"),
                    className: "btn-primary",
                    callback: () => {
                        const digits = Array
                            .from(document.querySelectorAll<HTMLInputElement>(".otp-digit"))
                            .map(i => i.value.trim());
                        if (digits.some(d => d.length !== 1 || !/^\d$/.test(d))) {
                            const err = document.getElementById("otpError");
                            err && err.classList.remove("d-none");
                            return false;
                        }
                        resolve(digits.join(""));
                    }
                }
            }
        });

        dlg.on("shown.bs.modal", () => {
            const inputs = Array.from(document.querySelectorAll<HTMLInputElement>(".otp-digit"));
            if (!inputs.length) return;
            inputs[0].focus();

            const focusNext = (idx: number) => {
                if (idx < inputs.length - 1) inputs[idx + 1].focus();
            };
            const focusPrev = (idx: number) => {
                if (idx > 0) inputs[idx - 1].focus();
            };
            const clearError = () => {
                const err = document.getElementById("otpError");
                err && err.classList.add("d-none");
            };

            inputs.forEach((inp, idx) => {
                inp.addEventListener("keydown", (e) => {
                    const key = e.key;

                    // Consenti scorciatoie standard (Ctrl/Meta + v,c,a,x)
                    if ((e.ctrlKey || e.metaKey) && /^[vcax]$/i.test(key)) {
                        return; // non bloccare, permette il paste con Ctrl+V
                    }

                    if (key === "Backspace" || key === "Delete") {
                        if (inp.value === "") {
                            focusPrev(idx);
                            const prev = inputs[idx - 1];
                            if (prev) prev.value = "";
                        } else {
                            inp.value = "";
                        }
                        e.preventDefault();
                        clearError();
                        return;
                    }

                    if (key === "ArrowLeft") {
                        focusPrev(idx);
                        e.preventDefault();
                        return;
                    }
                    if (key === "ArrowRight") {
                        focusNext(idx);
                        e.preventDefault();
                        return;
                    }

                    if (!/^\d$/.test(key) && key.length === 1) {
                        e.preventDefault();
                        return;
                    }
                });

                inp.addEventListener("input", (e) => {
                    const raw = (e.target as HTMLInputElement).value;
                    // Gestisce casi di più caratteri (es. tastiera mobile)
                    const digits = raw.replace(/\D+/g, "").slice(0, 6);
                    if (digits.length <= 1) {
                        inp.value = digits;
                        if (digits.length === 1) {
                            focusNext(idx);
                        }
                    } else {
                        // Distribuisce le cifre in cascata
                        let j = idx;
                        for (let d of digits) {
                            if (j < inputs.length) {
                                inputs[j].value = d;
                                j++;
                            } else break;
                        }
                        if (j - 1 < inputs.length) inputs[Math.min(j, inputs.length - 1)].focus();
                    }
                    clearError();
                });

                inp.addEventListener("paste", (e) => {
                    e.preventDefault();
                    const clip = (e.clipboardData?.getData("text") || "").replace(/\D+/g, "").slice(0, 6);
                    if (!clip) return;
                    inputs.forEach(i => i.value = "");
                    for (let i = 0; i < clip.length && i < inputs.length; i++) {
                        inputs[i].value = clip[i];
                    }
                    const nextEmpty = inputs.find(i => i.value === "");
                    (nextEmpty || inputs[inputs.length - 1]).focus();
                    clearError();
                });
            });
            const link = document.getElementById("otpResendLink");
            const linkTimeout = document.getElementById("otpResendLinkTimeout");
            if (link) {
                link.addEventListener("click", (e) => {
                    e.preventDefault();
                    dlg.modal("hide");
                    reject(new Error("resend"));
                });
            }
            if (linkTimeout && !resend) {
                linkTimeout.addEventListener("click", (e) => {
                    e.preventDefault();
                    dlg.modal("hide");
                    reject(new Error("resend"));
                });
                UI.delay(10 * 1000).then(() => {
                    console.log("resend link");
                    linkTimeout.parentElement?.classList.remove("d-none");
                });
            }
            
        });
    });
};




let loaderHtml: string | null = null;
let loaderContentHtml: string | null = null;
let isSpinning = false;

// public hide() : Component {
//
//     let el = this.domElement;
//     if (el) {
//         el.classList.add("hidden");
//         // Imposta il valore inline a "none"
//         el.style.display = "none";
//     }
//     return this;
//
// }



const showWait = () => {
    // let el = document.getElementById(domSelectors.Spinner);
    // if (el) {
    //     el.classList.remove("invisible");
    //     el.classList.remove("hidden");
    //     // Rimuove il valore inline, in modo che il browser usi il valore di default o quello determinato dal CSS
    //     el.style.display = "";
    //
    //     // Se l'elemento è ancora nascosto, imposta un valore di default (in questo caso "block")
    //     if (window.getComputedStyle(el).display === "none") {
    //         el.style.display = "block";
    //     }
    // }

    if (loaderHtml === null) {
        console.log("=====>", domSelectors.Spinner);
        let loaderEl = document.querySelector(domSelectors.Spinner);
        if (loaderEl) {
            loaderContentHtml = loaderEl.innerHTML;
            loaderEl.innerHTML = "";
            loaderHtml = loaderEl.outerHTML;
            loaderEl.remove();
        } else {
            loaderHtml = `<div class="page-loader-se" id="loading2"/>`;
            loaderContentHtml = '<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>';
        }
    }

    if (isSpinning) return;
    $.blockui.on({
        //content: '<h3>Loading...</h3>',
        content: loaderContentHtml,
        loader: loaderHtml,

        overlayCSS: {
            backgroundColor: '#000',
            opacity: 0.4,
        },
    });
    isSpinning = true;

}

const hideWait = () => {
    //$("#loading").css("display", "none");
    $.blockui.off();
    isSpinning = false;
}

// Utility di formattazione data/ora da ISO 8601 (es. 2025-07-17T15:15:55)
const pad2 = (n: number) => n.toString().padStart(2, "0");

/**
 * Converte una stringa ISO (es. 2025-07-17T15:15:55) in formato dd/MM/yyyy.
 * Ritorna '' se la data non è valida.
 */
const formatDateIsoToIt = (iso: string): string => {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    const day = pad2(d.getDate());
    const month = pad2(d.getMonth() + 1);
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
};

/**
 * Estrae solo l'orario da una stringa ISO in formato hh:mm:ss.
 * Ritorna '' se la data non è valida.
 */
const formatTimeIsoToHms = (iso: string): string => {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    const hh = pad2(d.getHours());
    const mm = pad2(d.getMinutes());
    const ss = pad2(d.getSeconds());
    return `${hh}:${mm}:${ss}`;
};


/**
 * Converte un numero (es. 650000 o "650000") in formato currency euro.
 * 650000 -> 650.000 € ; 650000.5 -> 650.000,50 € ; -1234.7 -> -1.234,70 €
 * Ritorna '' se il valore non è valido.
 */
const formatEuroCurrency = (value: number | string): string => {
    if (value === null || value === undefined || value === "") return "";
    const num = Number(value);
    if (!isFinite(num)) return "";
    const sign = num < 0 ? "-" : "";
    const abs = Math.abs(num);
    const hasDecimals = !Number.isInteger(abs);
    const raw = abs.toFixed(hasDecimals ? 2 : 0); // "650000" o "650000.50"
    const [intPart, decPart] = raw.split(".");
    // Formattazione migliaia
    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const formattedDec = hasDecimals ? "," + decPart : "";
    return `${sign}${formattedInt}${formattedDec} €`;
};


/**
* Converte una stringa in formato italiano(DD / MM / YYYY HH: MM: SS) in un oggetto Date.
* Supporta anche il formato senza secondi: DD / MM / YYYY HH: MM
* Ritorna null se il formato non è valido.
* 
* @param dataString - Data in formato "25/02/2026 23:59:00" o "25/02/2026 23:59"
* @returns Date | null
* 
* @example
* parseDataItaliana("25/02/2026 23:59:00") // Date(2026, 1, 25, 23, 59, 0)
* parseDataItaliana("01/01/2026 00:00")    // Date(2026, 0, 1, 0, 0, 0)
* parseDataItaliana("invalid")             // null
*/
const parseDataItaliana = (dataString: string): Date | null => {
    if (!dataString) return null;

    try {
        // Split data e ora: "25/02/2026 23:59:00" -> ["25/02/2026", "23:59:00"]
        const parts = dataString.trim().split(' ');
        if (parts.length !== 2) return null;

        const [dataPart, oraPart] = parts;

        // Split componenti data: "25/02/2026" -> ["25", "02", "2026"]
        const dateComponents = dataPart.split('/');
        if (dateComponents.length !== 3) return null;

        const [giorno, mese, anno] = dateComponents.map(Number);

        // Split componenti ora: "23:59:00" -> ["23", "59", "00"]
        const timeComponents = oraPart.split(':');
        if (timeComponents.length < 2 || timeComponents.length > 3) return null;

        const [ore, minuti, secondi = 0] = timeComponents.map(Number);

        // Validazione base dei valori
        if (
            isNaN(giorno) || isNaN(mese) || isNaN(anno) ||
            isNaN(ore) || isNaN(minuti) || isNaN(secondi) ||
            mese < 1 || mese > 12 ||
            giorno < 1 || giorno > 31 ||
            ore < 0 || ore > 23 ||
            minuti < 0 || minuti > 59 ||
            secondi < 0 || secondi > 59
        ) {
            return null;
        }

        // Crea la data (mese - 1 perché JavaScript conta i mesi da 0)
        const data = new Date(anno, mese - 1, giorno, ore, minuti, secondi);

        // Verifica che la data sia valida (es. 31/02/2026 diventa 03/03/2026)
        if (
            data.getDate() !== giorno ||
            data.getMonth() !== mese - 1 ||
            data.getFullYear() !== anno
        ) {
            return null;
        }

        return data;
    } catch (error) {
        console.error(`Errore parsing data "${dataString}":`, error);
        return null;
    }
};

const UI = {
    bindWaiting,
    unbindWaiting,
    delay,
    message,
    confirm,
    confirmWithButtonOkCustom,
    confirmOneButton,
    confirmOneButtonCustom,
    promptOtp,
    showWait,
    hideWait,
    formatDateIsoToIt,
    formatTimeIsoToHms,
    formatEuroCurrency,
    parseDataItaliana
}

export default UI;
export * from './ui';